module.exports = __webpack_public_path__ + "img/logout.e81727ee.svg";